export default function(){
    (function($) {

        var swipers = [];
        function slider() {

            if(swipers.length > 0){
                swipers.forEach((swiper) => {
                    swiper.destroy()
                });
            }


            $(".history-slider").each(function () {
                var $slider = $( this );
                swipers.push( new Swiper($slider.find('.swiper-container').get(0), {
                    slidesPerView: 'auto',
                    loop: false,
                    spaceBetween: 22,
                    freeMode: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    scrollbar: {
                        el: ".swiper-scrollbar",
                        hide: false,
                        draggable: true,
                    },
                    767: {
                        freeMode: false,
                    },
                    on: {
                        slideChange: function (swiper) {
                            //add active class to current button
                            var currentIndex = swiper.activeIndex;
                            var $slide = $slider.find('.swiper-slide')[currentIndex].getAttribute('data-slide');
                            var $button = $slider.parent().find('button');
                            $button.removeClass('active');
                            $slider.parent().find('button[data-target="'+$slide+'"]').addClass('active');
                        },
                    },
                }));


                $slider.swiper = swipers[swipers.length - 1];
                //Slides to slide with id same as data-target of clicked button
                var $button = $slider.parent().find('button');
                for (var $i = 0; $i < $button.length; $i++) {
                    $($button).click(function() {
                        var $targetID = '#'+$(this).data('target');
                        $slider.swiper.slideTo( $($targetID).index(), 500 );
                    });
                }


            });

        };

        $( window ).on( 'load resize', function() {
            slider();
        });



        $(".products").each(function () {
            var $this = $( this );
            var Products = new Swiper($this.find(".products__main").get(0), {
                slidesPerView: 'auto',
                loop: false,
                spaceBetween: 0,
                freeMode: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                scrollbar: {
                    el: ".swiper-scrollbar",
                    hide: false,
                    draggable: true,
                },
                767: {
                    freeMode: false,
                },
            });
            window.onresize=function(){
                Products.update();
            }
        });

        $(".history-btns").each(function () {
            var $this = $( this );
            var HistoryMenu = new Swiper($this.find('.swiper-container').get(0), {
                slidesPerView: 'auto',
                loop: false,
                spaceBetween: 0,
                freeMode: true,
                scrollbar: {
                    el: ".swiper-scrollbar",
                    hide: false,
                    draggable: true,
                },
                767: {
                    freeMode: false,
                },
            });
            window.onresize=function(){
                HistoryMenu.update();
            }
        });



            // $(".history").each(function () {
            //     var $this = $( this );
            //         var history = new Swiper($this.find(".swiper-container").get(0), {
            //             slidesPerView: 'auto',
            //             loop: false,
            //             spaceBetween: 22,
            //             freeMode: true,
            //             navigation: {
            //                 nextEl: '.swiper-button-next',
            //                 prevEl: '.swiper-button-prev',
            //             },
            //             scrollbar: {
            //                 el: ".swiper-scrollbar",
            //                 hide: false,
            //                 draggable: true,
            //             },
            //             767: {
            //                 freeMode: false,
            //             },
            //             on: {
            //                 slideChange: function (swiper) {
            //                     //add active class to current button
            //                     var currentIndex = swiper.activeIndex;
            //                     var $slide = $this.find('.swiper-slide')[currentIndex].getAttribute('data-slide');
            //                     var $button = $this.find('button');
            //                     $button.removeClass('active');
            //                     $this.find('button[data-target="'+$slide+'"]').addClass('active');
            //                 },
            //             },
            //         });
            //         window.onresize=function(){
            //             history.update();
            //         }
            //
            //         //Slides to slide with id same as data-target of clicked button
            //         var $button = $this.parent().find('button');
            //         for (var $i = 0; $i < $button.length; $i++) {
            //         $($button).click(function() {
            //             var $targetID = '#'+$(this).data('target');
            //             history.slideTo( $($targetID).index() );
            //         });
            //     }
            //
            // });



        $(".navigation-info").each(function () {
            var $this = $( this );
            var infoSlider = new Swiper($this.find('.swiper-container').get(0), {
                slidesPerView: 1,
                loop: $this.find('.swiper-slide').length > 1 ? true : false,
                autoplay: {
                    delay: 5000,
                },
                speed: 400,
                spaceBetween: 0,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints: {
                    1200: {
                        noSwipingSelector: 'span',
                    },
                },
            });
            window.onresize=function(){
                infoSlider.update();
            }

            if($this.find(".swiper-slide").length === 1){
                infoSlider.destroy();
                $(".navigation-info-nav").css("display", "none");
            }
        });


    })(jQuery);
}
